import web3 from './web3';

const address = '0x90D5eb808e8463239262c0f476A2BF0f29B6811b'

const abi = [{
    "inputs":[],
    "stateMutability":"nonpayable",
    "type":"constructor"
},
{
    "anonymous":false,
    "inputs":[{
        "indexed":true,
        "internalType":"address",
        "name":"owner",
        "type":"address"
    },
    {
        "indexed":true,
        "internalType":"address",
        "name":"spender",
        "type":"address"
    },
    {
        "indexed":false,
        "internalType":"uint256",
        "name":"value",
        "type":"uint256"
    }],
    "name":"Approval",
    "type":"event"
},
{
    "anonymous":false,
    "inputs":[{
        "indexed":false,
        "internalType":"uint256",
        "name":"amount",
        "type":"uint256"
    }],
    "name":"Bought",
    "type":"event"},
    {"anonymous":false,
    "inputs":[{
        "indexed":true,
        "internalType":"address",
        "name":"previousOwner",
        "type":"address"
    },
    {
        "indexed":true,
        "internalType":"address",
        "name":"newOwner",
        "type":"address"
    }],
    "name":"OwnershipTransferred",
    "type":"event"
},
{
    "anonymous":false,
    "inputs":[{
        "indexed":false,
        "internalType":"uint256",
        "name":"amount",
        "type":"uint256"
    }],
    "name":"Sold",
    "type":"event"
},
{
    "anonymous":false,
    "inputs":[{
        "indexed":true,
        "internalType":"address",
        "name":"from",
        "type":"address"
    },
    {
        "indexed":true,
        "internalType":"address",
        "name":"to",
        "type":"address"
    },
    {
        "indexed":false,
        "internalType":"uint256",
        "name":"value",
        "type":"uint256"
    }],
    "name":"Transfer",
    "type":"event"
},
{
    "inputs":[{
        "internalType":"uint256",
        "name":"BUSDamount",
        "type":"uint256"
    }],
    "name":"AmountYouGetForBUSDwhenMinting",
    "outputs":[{
        "internalType":"uint256",
        "name":"","type":"uint256"
    }],
    "stateMutability":"view",
    "type":"function"
},
{
    "inputs":[],
    "name":"BUSD",
    "outputs":[{
        "internalType":"contract IERC20",
        "name":"",
        "type":"address"
    }],
    "stateMutability":"view",
    "type":"function"
},
{
    "inputs":[],
    "name":"RHT",
    "outputs":[{
        "internalType":"contract IERC20",
        "name":"",
        "type":"address"}],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[],
        "name":"TriggerForShowAllUpdated",
        "outputs":[],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[{
            "internalType":"address",
            "name":"owner",
            "type":"address"
        },
        {
            "internalType":"address",
            "name":"spender",
            "type":"address"
        }],
        "name":"allowance",
        "outputs":[{
            "internalType":"uint256",
            "name":"",
            "type":"uint256"
        }],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[{
            "internalType":"address",
            "name":"spender",
            "type":"address"
        },
        {
            "internalType":"uint256",
            "name":"amount",
            "type":"uint256"
        }],
        "name":"approve",
        "outputs":[{
            "internalType":"bool",
            "name":"","type":"bool"
        }],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[],
        "name":"balanceInPool",
        "outputs":[{
            "internalType":"uint256",
            "name":"",
            "type":"uint256"
        }],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[{
            "internalType":"address",
            "name":"account",
            "type":"address"
        }],
        "name":"balanceOf",
        "outputs":[{
            "internalType":"uint256",
            "name":"",
            "type":"uint256"
        }],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[{
            "internalType":"address",
            "name":"account",
            "type":"address"
        }],
        "name":"balanceOfWithoutFee",
        "outputs":[{
            "internalType":"uint256",
            "name":"",
            "type":"uint256"
        }],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[{
            "internalType":"uint256",
            "name":"amount",
            "type":"uint256"
        }],
        "name":"burn",
        "outputs":[],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[{
            "internalType":"address",
            "name":"account",
            "type":"address"
        },
        {
            "internalType":"uint256",
            "name":"amount",
            "type":"uint256"
        }],
        "name":"burnFrom",
        "outputs":[],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[{
            "internalType":"uint256",
            "name":"BUSDamount",
            "type":"uint256"
        }],
        "name":"buyRHT",
        "outputs":[],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[],
        "name":"decimals",
        "outputs":[{
            "internalType":"uint8",
            "name":"",
            "type":"uint8"
        }],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[{
            "internalType":"address",
            "name":"spender",
            "type":"address"
        },
        {
            "internalType":"uint256",
            "name":"subtractedValue",
            "type":"uint256"
        }],
        "name":"decreaseAllowance",
        "outputs":[{
            "internalType":"bool",
            "name":"",
            "type":"bool"
        }],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[{
            "internalType":"uint256",
            "name":"_sentAmount",
            "type":"uint256"
        }],
        "name":"getReceivedAmount",
        "outputs":[{
            "internalType":"uint256",
            "name":"receivedAmount",
            "type":"uint256"
        },
        {
            "internalType":"uint256",
            "name":"feeAmount",
            "type":"uint256"
        }],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[{
            "internalType":"uint256",
            "name":"_receivedAmount",
            "type":"uint256"
        }],
        "name":"getSendAmount",
        "outputs":[{
            "internalType":"uint256",
            "name":"sendAmount",
            "type":"uint256"
        },
        {
            "internalType":"uint256",
            "name":"feeAmount",
            "type":"uint256"
        }],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[{
            "internalType":"address",
            "name":"spender",
            "type":"address"
        },
        {
            "internalType":"uint256",
            "name":"addedValue",
            "type":"uint256"
        }],
        "name":"increaseAllowance",
        "outputs":[{
            "internalType":"bool",
            "name":"",
            "type":"bool"
        }],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[],
        "name":"name",
        "outputs":[{
            "internalType":"string",
            "name":"",
            "type":"string"
        }],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[],
        "name":"owner",
        "outputs":[{
            "internalType":"address",
            "name":"",
            "type":"address"
        }],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[],
        "name":"renounceOwnership",
        "outputs":[],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[{
            "internalType":"uint256",
            "name":"RHTamountToSell",
            "type":"uint256"
        }],
        "name":"sellRHT",
        "outputs":[],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[{
            "internalType":"uint256",
            "name":"RHTamountToSell",
            "type":"uint256"
        }],
        "name":"sellRHTforOwnerOfRHTcontract",
        "outputs":[],
        "stateMutability":"nonpayable",
        "type":"function"
    },
    {
        "inputs":[],
        "name":"showRHTvalueForBuywithoutTrigger",
        "outputs":[{
            "internalType":"uint256",
            "name":"",
            "type":"uint256"
        }],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[],
        "name":"showRHTvalueForSellwithoutTrigger",
        "outputs":[{
            "internalType":"uint256",
            "name":"",
            "type":"uint256"
        }],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[],
        "name":"symbol",
        "outputs":[{
            "internalType":"string",
            "name":"",
            "type":"string"
        }],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[{
            "internalType":"uint256",
            "name":"",
            "type":"uint256"
        }],
        "name":"tokenBurns",
        "outputs":[{
            "internalType":"uint256",
            "name":"timestamp",
            "type":"uint256"
        },
        {
            "internalType":"uint256",
            "name":"amount",
            "type":"uint256"
        },
        {
            "internalType":"uint256",
            "name":"timeLeft",
            "type":"uint256"
        }],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[],
        "name":"tokenBurnsLenght",
        "outputs":[{
            "internalType":"uint256",
            "name":"",
            "type":"uint256"
        }],
        "stateMutability":"view",
        "type":"function"
    },
    {
        "inputs":[],
        "name":"totalSupply",
        "outputs":[{
            "internalType":"uint256",
            "name":"",
            "type":"uint256"}],
            "stateMutability":"view",
            "type":"function"
        },
        {
            "inputs":[],
            "name":"totalSupplyWholeNumber",
            "outputs":[{
                "internalType":"uint256",
                "name":"",
                "type":"uint256"
            }],
            "stateMutability":"view",
            "type":"function"
        },
        {
            "inputs":[{
                "internalType":"address",
                "name":"to",
                "type":"address"
            },
            {
                "internalType":"uint256",
                "name":"amount",
                "type":"uint256"
            }],
            "name":"transfer",
            "outputs":[{
                "internalType":"bool",
                "name":"",
                "type":"bool"
            }],
            "stateMutability":"nonpayable",
            "type":"function"
        },
        {
            "inputs":[{
                "internalType":"address",
                "name":"_to",
                "type":"address"
            },
            {
                "internalType":"uint256",
                "name":"_value",
                "type":"uint256"
            }],
            "name":"transferExactDest",
            "outputs":[{
                "internalType":"bool",
                "name":"success",
                "type":"bool"
            }],
            "stateMutability":"nonpayable",
            "type":"function"
        },
        {
            "inputs":[{
                "internalType":"address",
                "name":"_from",
                "type":"address"
            },
            {
                "internalType":"address",
                "name":"_to",
                "type":"address"
            },
            {
                "internalType":"uint256",
                "name":"_value",
                "type":"uint256"
            }],
            "name":"transferExactDestFrom",
            "outputs":[{
                "internalType":"bool",
                "name":"success",
                "type":"bool"
            }],
            "stateMutability":"nonpayable",
            "type":"function"
        },
        {
            "inputs":[{
                "internalType":"address",
                "name":"from",
                "type":"address"
            },
            {
                "internalType":"address",
                "name":"to",
                "type":"address"
            },
            {
                "internalType":"uint256",
                "name":"amount",
                "type":"uint256"
            }],
            "name":"transferFrom",
            "outputs":[{
                "internalType":"bool",
                "name":"",
                "type":"bool"
            }],
            "stateMutability":"nonpayable",
            "type":"function"
        },
        {
            "inputs":[{
                "internalType":"address",
                "name":"newOwner",
                "type":"address"
            }],
            "name":"transferOwnership",
            "outputs":[],
            "stateMutability":"nonpayable",
            "type":"function"
        },
        {
            "inputs":[],
            "name":"valueForBuy",
            "outputs":[{
                "internalType":"uint256",
                "name":"",
                "type":"uint256"
            }],
            "stateMutability":"view",
            "type":"function"
        },
        {
            "inputs":[],
            "name":"valueForSell",
            "outputs":[{
                "internalType":"uint256",
                "name":"",
                "type":"uint256"
            }],
            "stateMutability":"view",
            "type":"function"
        }]

export default new web3.eth.Contract(abi, address);